import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * BusStop
 */
export const busStopStyles = ({ theme }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-bottom: ${pxToRem(theme.spacing['400'])};
	}
`;
export const StyledBusStop = styled.nav `
	${busStopStyles}
`;
/**
 * BusStop List
 */
export const busStopListStyles = () => css `
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: row;
	max-width: none;
	list-style: none;
	counter-reset: section;
`;
export const StyledBusStopList = styled.ol `
	${busStopListStyles}
`;
